import type { Address } from 'viem'
import { pulsechain } from 'wagmi/chains'

export function trimAddress(address?: string, length?: number): string {
  return !address ? '…' : `${address?.slice(0, length || 6)}...${address?.slice(length ? 2 - length : -4)}`
}

export const LISTING_MULTIPLIER = 32

export const PRICE_MIN = (chainId?: number) => chainId === pulsechain.id ? 0.00002 : 0.00002
export const PRICE_MAX = PRICE_MIN() * LISTING_MULTIPLIER

export function getBcProgress(price: number, token?: Address) {
  const _price_max = bondingExceptions.x8.map(item => item.toLowerCase()).includes(`${token}`.toLowerCase())
    ? PRICE_MIN() * 8
    : bondingExceptions.x32.map(item => item.toLowerCase()).includes(`${token}`.toLowerCase())
      ? PRICE_MIN() * 32
      : PRICE_MAX

  try {
    if (price <= PRICE_MIN()) return 0
    if (price >= _price_max) return 100

    return ((price - PRICE_MIN()) / (_price_max - PRICE_MIN())) * 100
  } catch (e) {
    return 0
  }
}

/** @dev Flare-blockchain-based token addreses */
export const bondingExceptions = {
  x8: [
    '0x8FBC9193a5a68cE4f65060534E87Be485A715055' /* DRKT x8 (min_price (0.00002) * 8 = 0.00016) bonding */,
    '0xa2F32BFe742F8684616f456c5D9A5A5aa1b82121' /* GOAT x8 bonding */,
    '0x143640761165d3A3C298F6eaB0126C00AFb75D4e' /* FINU/FPUMP x8 bonding */,
  ],
  x32: [
    '0xd86D7352f63e2E8818455Ff3DB93ec07F8f3E6CA' /* Maid bonded at x32 */,
    '0xCc5AA4AEE43eE204BC73935f0385d830b7d25BA2' /* KWT bonded at x32 */,
  ],
}
